import type { LoginRequest, LoginResult, ChangePasswordRequest, UserDto } from "@evolys/types";
import { ApiClient } from "./client";

export class AuthApi {
  constructor(private client: ApiClient) {}

  login(data: LoginRequest): Promise<LoginResult> {
    return this.client.post<LoginResult>("/api/auth/login", data);
  }

  logout(): Promise<void> {
    return this.client.post<void>("/api/auth/logout");
  }

  me(): Promise<LoginResult> {
    return this.client.get<LoginResult>("/api/auth/me");
  }

  changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
    return this.client.post<{ message: string }>("/api/auth/change-password", data);
  }
}
